import { Button, Col, Row, Select } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  ul {
    list-style: none;
    text-align: center;
    margin: 0;
    padding: 0;
  }
  li:hover {
    color: orange;
  }
  .background {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url('https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/select-enterprise-image-2.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    padding: 15px;
    /* height: 100%; */
    background-position: center;
  }

  .hero-text {
    text-align: center;
    position: absolute;
    top: 50%;
    right: 10%;
    transform: translate(-50%, -50%);
  }
`;

const { Option } = Select;

interface MyEnterpriseListComponentProps {
  enterprises: any[];
  moveToMain: (enterprise: any) => void;
}

function MyEnterpriseListComponent({
  enterprises,
  moveToMain,
}: MyEnterpriseListComponentProps) {
  const [options, setOptions] = useState<any>();
  const [value, setValue] = useState(null);

  useEffect(() => {
    const children: any[] = [];
    for (const enterprise of enterprises) {
      children.push(
        <Option key={enterprise.id} value={enterprise.id}>
          {enterprise.name}
        </Option>,
      );
    }
    setOptions(children);
  }, [enterprises]);

  const handleChange = (value: any) => {
    setValue(value);
  };

  return (
    <StyledDiv>
      <Row>
        <Col span={8}>
          <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
            <Col>
              <Row justify="center">
                <h1>하이공사</h1>
              </Row>
              <Row justify="center">
                <h3>회사 선택</h3>
              </Row>
              <Row justify="center">
                <Col>
                  <Row justify="center">
                    <Select style={{ width: '200px' }} onChange={handleChange}>
                      {options}
                    </Select>
                  </Row>
                </Col>
              </Row>
              <Row justify="center">
                <Col>
                  <Button
                    style={{ width: '100px', marginTop: '20px' }}
                    onClick={() =>
                      moveToMain(
                        enterprises.find(
                          (enterprise) => enterprise.id === value,
                        ),
                      )
                    }
                    disabled={value === null}
                  >
                    다음
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col
          span={16}
          className="background"
          // style={{
          //   backgroundImage: "url(
          //     'https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/select-enterprise-image.jpg'
          //   )",
          //   backgroundSize: 'cover',
          // }}
        >
          {/* <div className="hero-text">
            <h1 style={{ fontSize: '30px', color: 'white' }}>
              로그인할 회사를 선택 하세요.
            </h1>
          </div> */}
          <Row align="middle" style={{ minHeight: '100vh' }}>
            <Col>
              <span
                style={{
                  fontSize: '30px',
                  color: 'white',
                  fontWeight: 'bold',
                  marginLeft: '60px',
                }}
              >
                로그인할 회사를 선택 하세요.
              </span>
            </Col>
          </Row>

          {/* <img
            src="https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/select-enterprise-image.jpg"
            // width="100%"
            height="100%"
            alt="testA"
          /> */}
          {/* <img
            className="background"
            alt="testA"
            src="https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/select-enterprise-image.jpg"
          /> */}
          {/* <div className="background"></div> */}
        </Col>
      </Row>
    </StyledDiv>
  );
}

export default MyEnterpriseListComponent;
